import "@fontsource-variable/manrope";
import "@fontsource-variable/newsreader";
import "@fontsource-variable/newsreader/wght-italic.css";
import "@rainbow-me/rainbowkit/styles.css";
import { RainbowKitProvider, lightTheme } from "@rainbow-me/rainbowkit";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { WagmiProvider } from "wagmi";
import { base } from "wagmi/chains";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { wagmiConfig } from "./lib/wagmi";
import { WalletProvider } from "./lib/wallet";
import "./kyndo.css";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          initialChain={base}
          modalSize="compact"
          theme={lightTheme({
            accentColor: "#213d32",
            accentColorForeground: "#f5f5ed",
            borderRadius: "small",
            fontStack: "system",
          })}
        >
          <ErrorBoundary>
            <BrowserRouter>
              <WalletProvider>
                <App />
              </WalletProvider>
            </BrowserRouter>
          </ErrorBoundary>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </StrictMode>
);
